import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueConfirmDialog from 'vue-confirm-dialog'
import firebase from 'firebase/app'
import 'firebase/auth'
import './assets/main.css'
import VueCookie from 'vue-cookie'
import VueMeta from 'vue-meta'
import { PostAuthUserLoginProcess } from '@/helpers/users.js'
import { cookies } from '@/util/cookies'


Vue.config.productionTip = false

Vue.use(VueConfirmDialog)
Vue.use(VueCookie)
Vue.use(VueMeta)

Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

const baseUrl = window.location.origin
const url = window.location.href
if (url.startsWith(baseUrl)) {
  const hash = url.substring(baseUrl.length, baseUrl.length + 3)
  if (hash !== '/#/') {
    const path = url.substring(baseUrl.length)
    const newFullPath = baseUrl + '/#' + path
    window.history.replaceState(null, null, newFullPath)
  }
}

router.beforeEach(async (to, from, next) => {
  console.log('before each')

  const iframe = process.env.VUE_APP_IS_IFRAME && process.env.VUE_APP_IS_IFRAME === 'true'
  console.log('iframe', iframe)
  if (!iframe) {
    const authenticated = store.getters.isAuthenticated
    if ((to.matched.some(record => record.meta.requiresAuth) && !authenticated)) {
      console.log('cookie: ' + VueCookie.get('toPath'))
      console.log('fullPath: ' + to.fullPath)
      if (VueCookie.get('toPath') === null) {
        VueCookie.set('toPath', to.fullPath)
      }
      console.log('beforeRouteEnter going to ' + to.name + ' (requires auth = ' + to.meta.requiresAuth + ') redirecting to login')
      next({
        name: 'Login',
        query: { redirect: to.fullPath },
      })
      return
    }
    // check the user has the necessary roles, by checking meta.roles if empty just accept
    const roles = to.meta.roles
    if (roles && roles.length > 0) {
      if (!roles.some(role => store.getters.userHasRole(role))) {
        console.log('User has no required roles, redirecting')
        return
      }
    }
  }
  next()
})


// console.log(process.env.VUE_APP_FIREBASE_CONFIG)
console.log('Connecting to endpoints: ' + cookies.get('baseUrl') ?? process.env.VUE_APP_BODYSWAPS_API_ENDPOINT)
firebase.initializeApp(JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG))
// let app

console.log('Booting: ' + process.env.VUE_APP_DISPLAY_VERSION)
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

firebase.auth().onAuthStateChanged(async user => {
  // const iframe = process.env.VUE_APP_IS_IFRAME && process.env.VUE_APP_IS_IFRAME === 'true'
  // console.log(iframe)
  // if (!iframe) {
  console.log('onAuthStateChanged', user)
    if (user) {
      // user up
      if (!store.getters.isAuthenticated) {
        console.log('AuthUser ' + user.uid + ' logging in')
        try {
          await PostAuthUserLoginProcess(user, store, i18n)
        } catch (ex) {
          console.error('logging back out')
          firebase.auth().signOut()
        }
      }
    } else {
      console.log('User logged out')
    }
  // }

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
  }).$mount('#app')
})



